var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,3.7c0.7,0,1.3,0.2,1.9,0.4l1.2-0.6V3.1c0-0.6-0.5-1.1-1.1-1.1H1.4C0.8,2,0.3,2.5,0.3,3.1v0.5L8,7.4l0.1,0 C8.5,5.3,10.4,3.7,12.6,3.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,8.5L0.3,4.8v7.1c0,0.6,0.5,1.1,1.1,1.1h8.2C8.8,11.3,8.1,9.6,8,8.6C7.9,8.6,7.8,8.6,7.8,8.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,5c-1.9,0-3.4,1.5-3.4,3.4s3.4,7.4,3.4,7.4S16,10.3,16,8.4S14.4,5,12.6,5z M12.6,9.9 c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C14.3,9.2,13.5,9.9,12.6,9.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTrip);
export default __webpack_public_path__ + "static/media/email-trip.b4d920b779b40f96f30585df1aafbd27.svg";
export { ForwardRef as ReactComponent };